var render = function render(){var _vm=this,_c=_vm._self._c;return _c('auth-page',[_c('login-form',{staticClass:"login",attrs:{"route-params":_vm.routeParams,"route-path":_vm.routePath,"route-query":_vm.routeQuery}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }